export default [
  {id: 1, nome: 'VIGIA'},
  {id: 2, nome: 'AUXILIAR OPERACIONAL CONTÍNUO'},
  {id: 3, nome: 'AUXILIAR DE MANUTENÇÃO'},
  {id: 4, nome: 'AUXILIAR DE MECANICO'},
  {id: 5, nome: 'AUXILIAR DE JARDINAGEM'},
  {id: 6, nome: 'AUXILIAR SERV.GERAIS'},
  {id: 7, nome: 'ASSISTENTE DE ATENDIMENTO'},
  {id: 8, nome: 'ASSISTENTE OPERACIONAL'},
  {id: 9, nome: 'PORTEIRO'},
  {id: 1, nome: 'RECEPCIONISTA'},
  {id: 1, nome: 'VISTORIADOR'},
  {id: 1, nome: 'MOTORISTA'},
  {id: 1, nome: 'ASSISTENTE DE MANUTENÇÃO'},
  {id: 1, nome: 'ASSISTENTE ADMINISTRATIVO JR'},
  {id: 1, nome: 'ASSISTENTE ADMINISTRATIVO PL'},
  {id: 1, nome: 'OPERADOR DE EMPILHADEIRA'},
  {id: 1, nome: 'VISTORIADOR SENIOR'},
  {id: 1, nome: 'TÉCNICO DE SUPORTE'},
  {id: 1, nome: 'ANALISTA DE INFRAESTRUTURA'},
  {id: 2, nome: 'ASSISTISTENTE ADMINISTRATIVO SR'},
  {id: 2, nome: 'ASSISTENTE DE DESIGNER'},
  {id: 2, nome: 'ASSISTENTE COMERCIAL SR'},
  {id: 2, nome: 'JARDINEIRO'},
  {id: 2, nome: 'ENCARREGADO (ADM e OPERACIONAL)'},
  {id: 2, nome: 'SUPERVISOR DE LEILÃO'},
  {id: 2, nome: 'ANALISTA DE SUPORTE'},
  {id: 2, nome: 'SUPERVISOR ADMINISTRATIVO /FINANCEIRO'},
  {id: 2, nome: 'SUPERVISOR DE PÁTIO'},
  {id: 2, nome: 'GERENTE DE LOGÍSTICA'},
  {id: 3, nome: 'GERENTE DE CONTROLADORIA'},
  {id: 3, nome: 'GERENTE ADMINISTRATIVO/FINANCEIRO'},
  {id: 3, nome: 'GERENTE DE NEGÓCIOS'},
  {id: 3, nome: 'GERENTE DE TI'},
  {id: 3, nome: 'GERENTE DE LEILÕES'}
]



// WEBPACK FOOTER //
// ./src/app/website/trabalhe-conosco/lista-vagas.js